import { Tabs } from "@mantine/core"
import { ReactNode, useMemo } from "react"

import { ActivitiesAdminWrapper } from "~/pages/Admin/Ingestion/Activities"
import { OpChains } from "~/pages/Admin/Ingestion/OpChains"
import { OpChainContextProvider } from "~/pages/Admin/Ingestion/OpChains/store/op-chain-context"
import { ProductImport } from "~/pages/Admin/Ingestion/ProductImport"

type TabsElement = {
  label: string
  component: ReactNode
}

export function Ingestion() {
  const tabs = useMemo<TabsElement[]>(
    () => [
      {
        label: "Product Import",
        component: <ProductImport />,
      },
      {
        label: "OpChains",
        component: <OpChains />,
      },
      {
        label: "Activities",
        component: <ActivitiesAdminWrapper />,
      },
    ],
    []
  )

  return (
    <OpChainContextProvider>
      <Tabs defaultValue={tabs[0].label} w="100%">
        <Tabs.List>
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.label} value={tab.label}>
              {tab.label}
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {tabs.map((tab) => (
          <Tabs.Panel key={tab.label} value={tab.label}>
            {tab.component}
          </Tabs.Panel>
        ))}
      </Tabs>
    </OpChainContextProvider>
  )
}
